import { Link } from "react-router-dom";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { useAgents } from "@/components/Agents/AgentsContext";
import { agentsHref } from "@/lib/atwAgentsHost";
import { creditsRemaining, effectiveCreditsIncluded } from "@/lib/agentsDemoData";

export function AgentsHomePage() {
  const { org } = useAgents();
  const creditsIncluded = effectiveCreditsIncluded(org);
  const remaining = creditsRemaining(org);
  const activeAgents = org.agents.filter((agent) => agent.status !== "archived");
  const archivedAgents = org.agents.filter((agent) => agent.status === "archived");

  return (
    <div className="space-y-8">
      <div>
        <h1 className="text-2xl font-semibold text-gray-900 dark:text-white">Dashboard</h1>
        <p className="mt-1 text-sm text-gray-600 dark:text-gray-400">
          Workforce at a glance. Usage comes from the shared credit pool ({org.planLabel}).
        </p>
      </div>

      {org.overseer.length > 0 ? (
        <section className="rounded-lg border border-sky-200 bg-sky-50/80 px-4 py-3 dark:border-sky-900/40 dark:bg-sky-950/30">
          <p className="text-sm font-medium text-sky-900 dark:text-sky-100">Overseer highlights</p>
          <ul className="mt-2 space-y-1 text-sm text-sky-800 dark:text-sky-200">
            {org.overseer.slice(0, 3).map((row) => (
              <li key={row.id}>
                <Link to={agentsHref("/overseer")} className="underline underline-offset-2">
                  {row.agentName}
                </Link>
                : {row.summary}
              </li>
            ))}
          </ul>
        </section>
      ) : null}

      <div className="grid gap-4 sm:grid-cols-3">
        <Card>
          <CardHeader className="pb-2">
            <CardDescription>Active agents</CardDescription>
            <CardTitle className="text-2xl">{activeAgents.length}</CardTitle>
          </CardHeader>
          <CardContent className="text-xs text-muted-foreground">
            {archivedAgents.length} archived.{" "}
            <Link to={agentsHref("/agents")} className="underline underline-offset-2">
              Open agents
            </Link>
          </CardContent>
        </Card>
        <Card>
          <CardHeader className="pb-2">
            <CardDescription>Credits this month</CardDescription>
            <CardTitle className="text-2xl">
              {org.creditsUsed.toLocaleString()} / {creditsIncluded.toLocaleString()}
            </CardTitle>
          </CardHeader>
          <CardContent className="text-xs text-muted-foreground">
            Shared org pool{org.maxAddon ? " · Max (20×) on" : ""}.{" "}
            <Link to={agentsHref("/credits")} className="underline underline-offset-2">
              View credits
            </Link>
          </CardContent>
        </Card>
        <Card>
          <CardHeader className="pb-2">
            <CardDescription>Credits remaining</CardDescription>
            <CardTitle className="text-2xl">{remaining.toLocaleString()}</CardTitle>
          </CardHeader>
          <CardContent className="text-xs text-muted-foreground">
            {org.maxAddon ? "Max (20×) is on. " : ""}
            <Link to={agentsHref("/checkout")} className="underline underline-offset-2">
              Open Checkout
            </Link>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
